var _rect, _text, _text2, _rect2, _text3, _text4, _text5, _text6, _line, _polygon, _rect3, _text7, _text8, _text9, _text10, _line2, _polygon2, _rect4, _text11, _text12, _text13, _text14, _line3, _polygon3, _rect5, _text15, _text16, _text17, _text18, _path, _polygon4, _text19, _rect6, _text20, _text21, _text22, _text23, _text24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBehavioralIntelligenceLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 400",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boxGradBI",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#111111",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    rx: 8,
    fill: "#0C0C0C",
    stroke: "#DCCA87",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 32,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 11,
    fill: "#DCCA87",
    letterSpacing: 2,
    opacity: 0.7
  }, "BEHAVIORAL INTELLIGENCE \u2014 THE LEARNING LOOP")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 52,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#777777"
  }, "Session graphs provide structure. Behavioral intelligence provides meaning that compounds over time.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 90,
    width: 150,
    height: 100,
    rx: 6,
    fill: "url(#boxGradBI)",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 118,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#DCCA87",
    fontWeight: 500
  }, "OBSERVE")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 140,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "Session graphs")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 156,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "Context evolution")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 172,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "Tool interactions")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 140,
    x2: 260,
    y2: 140,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "260,136 268,140 260,144",
    fill: "#DCCA87",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 90,
    width: 150,
    height: 100,
    rx: 6,
    fill: "url(#boxGradBI)",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 118,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#DCCA87",
    fontWeight: 500
  }, "DETECT")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 140,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "Anomaly patterns")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 156,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "Instruction drift")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 172,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "Behavioral deviation")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 140,
    x2: 470,
    y2: 140,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "470,136 478,140 470,144",
    fill: "#DCCA87",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 90,
    width: 150,
    height: 100,
    rx: 6,
    fill: "url(#boxGradBI)",
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 118,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#DCCA87",
    fontWeight: 500
  }, "REASON")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 140,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "LLM causal analysis")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 156,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "Root-cause attribution")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 172,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "Absence detection")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 630,
    y1: 140,
    x2: 660,
    y2: 140,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "660,136 668,140 660,144",
    fill: "#DCCA87",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 90,
    width: 100,
    height: 100,
    rx: 6,
    fill: "url(#boxGradBI)",
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 118,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#DCCA87",
    fontWeight: 500
  }, "LEARN")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 140,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "Cross-session")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 156,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "patterns")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 172,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA"
  }, "compound")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M720,192 L720,250 C720,270 700,280 680,280 L120,280 C100,280 80,270 80,250 L80,192",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "none",
    strokeDasharray: "6,3"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "76,194 80,186 84,194",
    fill: "#DCCA87",
    fillOpacity: 0.4
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 276,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#DCCA87",
    opacity: 0.6
  }, "learned patterns feed back into detection \u2014 the system improves with every session")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 310,
    width: 640,
    height: 70,
    rx: 6,
    fill: "url(#boxGradBI)",
    stroke: "#DCCA87",
    strokeOpacity: 0.2,
    strokeWidth: 1
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 334,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#DCCA87",
    fontWeight: 500
  }, "WHAT COMPOUNDS (Proprietary Behavioral Models)")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 358,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#888888"
  }, "Failure signatures")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 358,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#888888"
  }, "Cost prediction")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 358,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#888888"
  }, "Drift baselines")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 358,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#888888"
  }, "Intervention rules")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehavioralIntelligenceLoop);
export default __webpack_public_path__ + "static/media/behavioral-intelligence-loop.ad892cb74f59f03cbbc286bf6dea485c.svg";
export { ForwardRef as ReactComponent };